import PropTypes from 'prop-types';
import { ItemType } from './ItemType.enum';

export const BadgeItem = {
	// unique identifier
	id: PropTypes.number.isRequired,

	// item type
	type: PropTypes.oneOf(Object.keys(ItemType)),

	// edit and delete button
	showTools: PropTypes.bool,

	// custom tool buttons
	toolButtons: PropTypes.array,

	// badge
	showBadge: PropTypes.bool,

	// feature gate
	showFeatureGate: PropTypes.bool,

	// vertical color bar
	showTag: PropTypes.bool,

	// title
	title: PropTypes.string,

	// content
	badge: PropTypes.any,

	// placeholder text for Search-type item
	placeholder: PropTypes.string,

	// hex color code
	tagColor: PropTypes.string,

	// visibility flag
	visible: PropTypes.bool,

	// the badge item is selected
	active: PropTypes.bool,

	// disabled flag
	disabled: PropTypes.bool,

	// dataqa attributes for automation purpose
	dataqa: PropTypes.string,

	// additional data
	data: PropTypes.object,
};
